<template>
	<div>
		<div class="list-btn">
			<Button type="primary" @click="ret">返回</Button>
		</div>
		<div class="content">

			<Form ref="formValidate" :model="formValidate" :rules="ruleValidate" :label-width="100">

				<Row>
					<Col span="">
					<FormItem label="公司名称" prop="companyName" class="" >
						<Input v-model="formValidate.companyName" placeholder="请输入公司名称" disabled></Input>
					</FormItem>
					</Col>
					<Col span="">
					<FormItem label="公司地址" prop="address" class="" >
						<Input v-model="formValidate.address" placeholder="请输入公司地址" disabled></Input>
					</FormItem>
					</Col>
					<Col span="">
					<FormItem label="联系方式1" prop="phone1" class="">
						<Input v-model="formValidate.phone1" placeholder="请输入联系方式"></Input>
					</FormItem>
					</Col>
					<Col span="">
					<FormItem label="联系方式2" prop="phone2" class="">
						<Input v-model="formValidate.phone2" placeholder="请输入联系方式"></Input>
					</FormItem>
					</Col>
					<Col span="">
					<FormItem label="联系方式3" prop="phone3" class="">
						<Input v-model="formValidate.phone3" placeholder="请输入联系方式(当联系方式超过三个时，用;进行分割)"></Input>
					</FormItem>
					</Col>
					<Col span="">
					<FormItem label="邮箱" prop="mailbox" class="">
						<Input v-model="formValidate.mailbox" placeholder="请输入名称"></Input>
					</FormItem>
					</Col>
				</Row>


				<FormItem>
					<Button type="primary" @click="handleSubmit('formValidate')">提交</Button>
				</FormItem>
			</Form>

		</div>
	</div>
</template>

<script>
	import http from '@/http/http.js'
	export default {
		data() {
			return {
				imgBool: true,
				formValidate: {
					companyName: '',
					address: '',
					phone1: '',
					phone2: '',
					phone3: '',
					mailbox: ''

				},
				ruleValidate: {
					phone1: [{
						required: true,
						message: '至少要有一个联系方式！！！',
						trigger: 'blur'
					}],
					companyName: [{
						required: true,
						message: '名称不能为空！！！',
						trigger: 'blur'
					}],
					mailbox: [{
							required: true,
							message: '邮箱不能为空',
							trigger: 'blur'
						},
						{
							type: 'email',
							message: '邮箱格式错误',
							trigger: 'blur'
						}
					]
				}

			}
		},
		methods: {
			ret() { //返回上一页
				this.$router.go(-1)
			},
			handleSubmit(name) {
				let _this=this
				this.$refs[name].validate((valid) => {
					if (valid) {
						http.http({
						    //这里是你自己的请求方式、url和data参数
						    method: 'post',
						    url: http.url + '/oper/update',
						    data: _this.formValidate,
							_this: _this,
							success: function(data) {
								_this.$Message.success('修改成功!');
							}
						    //假设后台需要的是表单数据这里你就可以更改
						  })
						
					} else {
						this.$Message.error('请完善信息后再进行提交!');
					}
				})
			},
			imgFile(files) {
				this.formValidate.img = files
				if (this.formValidate.img.length > 0) {
					this.imgBool = false
				} else {
					this.imgBool = true
				}
			}

		},
		components: {

		},
		created() {
			let _this=this
			http.http({
			    //这里是你自己的请求方式、url和data参数
			    method: 'post',
			    url: http.url + '/oper/findById',
			    data: {},
				_this: _this,
				success: function(data) {
					_this.formValidate = data.oper
				}
			    //假设后台需要的是表单数据这里你就可以更改
			  })
			



		}
	}
</script>

<style scoped="scoped">
	.list-btn {
		margin-bottom: 20px;
	}

	.content {
		margin-left: 10%;
		width: 900px;

	}

	.ivu-form-item {
		margin-bottom: 5px;
	}

	.ivu-col {
		margin-bottom: 20px;
	}
</style>



// WEBPACK FOOTER //
// src/components/oper/oper/update.vue